import angular from 'angular';
import uiRouter from 'angular-ui-router';
import accountingComponent from './accounting.component';
import ProductList from './productList/productList';
import InvoiceList from './invoiceList/invoiceList';
import EditInvoice from './editInvoice/editInvoice';
import AccountingService from './accounting.service';

let accountingModule = angular.module('accounting', [
  uiRouter,
  ProductList,
  InvoiceList,
  EditInvoice,
])

.component('accounting', accountingComponent)

.service('accountingService', AccountingService)

.name;

export default accountingModule;



// WEBPACK FOOTER //
// ./client/app/components/accounting/accounting.js